import { render, staticRenderFns } from "./OrderExchangeReject.vue?vue&type=template&id=7b9980f7&scoped=true"
import script from "./OrderExchangeReject.vue?vue&type=script&lang=js"
export * from "./OrderExchangeReject.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeReject.vue?vue&type=style&index=0&id=7b9980f7&prod&lang=scss&scoped=true"
import style1 from "./OrderExchangeReject.vue?vue&type=style&index=1&id=7b9980f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9980f7",
  null
  
)

export default component.exports